<template>
  <div class="content">
    <div class="container-fluid h-100">
      <card-item>
        <div class="row">
          <div class="col-12">
            <label class="label" for="vehiculo">Datos de contrato</label>
          </div>
        </div>
        <div class="row h-100">
          <form
            v-promise-btn="{ action: 'submit' }"
            @submit.prevent="submit"
            class="container"
          >
            <div class="container">
              <div class="row">
                <div class="col-12 col-md-6 form-group form-group-sm">
                  <label class="label" for="fechaAlta">Fecha de alta</label>
                  <input
                    id="fechaAlta"
                    v-model="fecha"
                    :class="`form-control form-control-sm text-center bg-white ${
                      !isFechaOk ? 'is-invalid' : ''
                    }`"
                    style="cursor: text"
                    type="datetime-local"
                  />
                </div>

                <SelectTipoContrato
                  v-model="idTipoContrato"
                  :class="` ${!isIdTipoContratoOk ? 'is-invalid' : ''}`"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-end">
                  <button class="btn btn-primary" type="submit">Aceptar</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </card-item>
    </div>
  </div>
</template>

<script>
import { get } from "lodash-es";
import SelectTipoContrato from "../Commons/SelectTipoContrato";
import { convertDateToString } from "../../../../lib/utils/dates";
import axios from "axios";

export default {
  name: "DatosContratoForm",
  components: {
    SelectTipoContrato,
  },
  computed: {
    idTipoContrato: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.tipoContrato;
      },
      set(val) {
        this.$store.commit("Contratos/ModificarContrato/setTipoContrato", val);
      },
    },
    fecha: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.fechaAlta;
      },
      set(val) {
        this.$store.commit("Contratos/ModificarContrato/setFechaAlta", val);
      },
    },
    isDataOk() {
      return this.isIdTipoContratoOk && this.isFechaOk;
    },
    isIdTipoContratoOk() {
      return this.tipoContrato !== "";
    },
    isFechaOk() {
      return this.fechaAlta !== "";
    },
  },
  methods: {
    async submit() {
      const idContrato = this.$route.params.id_contrato;

      const resp = await axios.post("/execute", {
        method: "CLI.ModificarDatosContrato",
        parameters: [
          {
            name: "id_contrato_tipo",
            value: this.idTipoContrato.id_contrato_tipos,
          },
          { name: "fecha_alta", value: convertDateToString(this.fecha) },
          { name: "id_contrato", value: idContrato },
        ],
      });

      if (get(resp, "data.ok", true)) {
        this.$msgBoxOk(
          `Se realizo el cambio de: Fecha a ${convertDateToString(
            this.fecha,
          )}  y/o  Tipo de Contrato: ${
            this.idTipoContrato.nombre_contrato
          }  con éxito`,
        );
      } else {
        this.$msgBoxOk(resp.message);
      }
    },
  },
};
</script>
<style></style>
